/**
 * @module providers/WagmiProvider
 * @category Providers
 * @description Mounts the wagmi (viem) context used by the marketplace hooks in
 * `src/hooks/` (useAuctionManager, useConfigurator, useDeployer, useNFT).
 *
 * This coexists with AppKit: AppKit remains the wallet UI and connection layer
 * for the existing containers, while the wagmi hooks read their own connector
 * state. TODO.md tracks migrating the rest of the project onto wagmi, after
 * which AppKit can be dropped.
 *
 * Rendered client-only — wagmi's `ssr: true` config plus this guard keep the
 * server render (src/entry-server.tsx) free of browser-only wallet access.
 */

import { ReactNode, useEffect, useState } from 'react';
import { WagmiProvider } from 'wagmi';
import { wagmiConfig } from '../lib/wagmi';

export function WagmiProviderWrapper({ children }: { children: ReactNode }) {
    // The provider must be present on the first render so hooks inside routes
    // never execute outside `WagmiProvider`.
    return <WagmiProvider config={wagmiConfig}>{children}</WagmiProvider>;
}

export default WagmiProviderWrapper;
